import React from 'react';
import { Link } from 'react-router-dom';

const Home: React.FC = () => {
  return (
    <div className="p-6">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold text-gray-900 mb-6">
          Welcome to MTG Budget Tracker
        </h1>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
          <Link to="/my-decks" className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow">
            <h2 className="text-xl font-semibold text-gray-800 mb-2">📦 My Decks</h2>
            <p className="text-gray-600 mb-4">
              Create, manage, and store your decks. Import from Archidekt or Moxfield.
            </p>
            <span className="inline-block bg-green-600 text-white px-4 py-2 rounded-lg">
              My Decks
            </span>
          </Link>

          <Link to="/my-tournaments" className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow">
            <h2 className="text-xl font-semibold text-gray-800 mb-2">📚 My Tournaments</h2>
            <p className="text-gray-600 mb-4">
              View tournaments you follow and your deck submissions.
            </p>
            <span className="inline-block bg-teal-600 text-white px-4 py-2 rounded-lg">
              My Tournaments
            </span>
          </Link>
          
          <Link to="/tournaments" className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow">
            <h2 className="text-xl font-semibold text-gray-800 mb-2">🏆 Tournaments</h2>
            <p className="text-gray-600 mb-4">
              View active tournaments and follow the ones you're interested in.
            </p>
            <span className="inline-block bg-purple-600 text-white px-4 py-2 rounded-lg">
              View Tournaments
            </span>
          </Link>
        </div>
        
        <div className="bg-blue-50 p-6 rounded-lg">
          <h2 className="text-xl font-semibold text-blue-800 mb-4">About MTG Budget Tracker</h2>
          <div className="space-y-3 text-blue-700">
            <p>
              MTG Budget Tracker is your comprehensive tool for managing Magic: The Gathering decks and tournaments with budget constraints. 
              Create and store your decks in "My Decks", import them from popular deckbuilding sites like Archidekt and Moxfield, 
              and easily submit them to tournaments when you're ready.
            </p>
            <p>
              Browse active tournaments, register to participate, and track your submissions. The platform automatically validates 
              your decks against tournament budget limits and format rules, ensuring fair play for everyone.
            </p>
            <p>
              Whether you're preparing for a budget tournament or just organizing your collection, MTG Budget Tracker helps you 
              stay on top of your deck building and tournament participation.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
